import { useMemo } from 'react'

import { InputNumber, Space } from 'antd'
import { createStyles } from 'antd-style'
import dayjs from 'dayjs'

import { TimeDurationInputProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap'
  },
  title: {
    flex: 'none',
    marginInlineEnd: token.marginXS
  },
  inptWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    gap: token.paddingXS,
    [`.${prefixCls}-input-number-group .${prefixCls}-input-number-group-addon`]:
      {
        paddingInline: token.paddingXXS
      }
  }
}))

export const TimeDurationInput = ({
  title,
  disabled,
  value,
  onChange
}: TimeDurationInputProps) => {
  const duration = useMemo(() => dayjs.duration(value * 60 * 1000), [value])

  const days = duration.days()
  const hours = duration.hours()
  const minutes = duration.minutes()

  const handleDayChange = (value: number | null) => {
    onChange(duration.add((value || 0) - days, 'day').asMinutes())
  }

  const handleHourChange = (value: number | null) => {
    onChange(duration.add((value || 0) - hours, 'hour').asMinutes())
  }

  const handleMinuteChange = (value: number | null) => {
    onChange(duration.add((value || 0) - minutes, 'minute').asMinutes())
  }

  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.inptWrapper}>
        <Space.Compact>
          <InputNumber
            disabled={disabled}
            min={0}
            value={days}
            style={{
              width: 50
            }}
            onChange={handleDayChange}
            onMouseDown={e => {
              // 阻止失焦
              e.stopPropagation()
            }}
          />
          <Space.Addon>天</Space.Addon>
        </Space.Compact>
        <Space.Compact>
          <InputNumber
            disabled={disabled}
            min={0}
            value={hours}
            style={{
              width: 60
            }}
            onChange={handleHourChange}
            onMouseDown={e => {
              e.stopPropagation()
            }}
          />
          <Space.Addon>小时</Space.Addon>
        </Space.Compact>
        <Space.Compact>
          <InputNumber
            disabled={disabled}
            min={0}
            value={minutes}
            style={{
              width: 60
            }}
            onChange={handleMinuteChange}
            onMouseDown={e => {
              e.stopPropagation()
            }}
          />
          <Space.Addon>分钟</Space.Addon>
        </Space.Compact>
      </div>
    </div>
  )
}
